export const SUBNETWORKS = {
  LGBTQ: "lgbtq",
  NATIVE: "native",
};
